module.exports = __webpack_public_path__ + "img/zurueck_handschrift_anim.5225dc9b.png";